import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { NotificationsState } from './notifications.state';

// Thin NgModule wrapper so the state can be imported directly into standalone
// component imports[] — identical pattern to KeyStateModule in ssh-keys.
@NgModule({ imports: [NgxsModule.forFeature([NotificationsState])] })
export class NotificationsStateModule {}
